// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   AgentSharePage — 공유 링크로 진입하는 공개 에이전트 채팅 (/agent/:token)
   ====================================================================== */

.agent-share {
  --agent-share-accent: #6c5ce7;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(1200px 600px at 90% -10%, color-mix(in srgb, var(--agent-share-accent) 12%, transparent), transparent 60%),
    radial-gradient(900px 600px at -10% 110%, color-mix(in srgb, var(--agent-share-accent) 10%, transparent), transparent 60%),
    var(--fg-bg-content, #f5f6fa);
  font-family: var(--font-sans);
  color: var(--fg-text-basic);
}

/* 상단 바 — 미니멀한 브랜드 표시만 */
.agent-share__topbar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
}

.agent-share__brand {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.agent-share__brand:hover,
.agent-share__brand:focus-visible {
  opacity: 0.75;
  outline: none;
}

.agent-share__brand-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: block;
}

.agent-share__brand-name {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--fg-text-basic);
}

/* 메인 — 중앙 컨테이너 */
.agent-share__main {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px 16px;
}

/* 헤더(에이전트 소개) */
.agent-share__hero {
  width: 100%;
  max-width: 800px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 24px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  border: 1px solid var(--fg-line);
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.agent-share__avatar {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 14px;
  background: var(--agent-share-accent);
  color: #fff;
}

.agent-share__hero-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.agent-share__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  color: var(--fg-text-basic);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agent-share__desc {
  margin: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--fg-text-gray);
}

.agent-share__desc--error {
  color: var(--fg-anti-red);
}

/* 채팅 컨테이너 */
.agent-share__chat {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 20px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.agent-share__scroller {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.agent-share__welcome {
  margin: auto;
  padding: 32px 16px;
  text-align: center;
  color: var(--fg-text-gray);
  font-size: 14px;
}

.agent-share__welcome p {
  margin: 0;
}

/* 메시지 버블 */
.agent-share__msg {
  display: flex;
  width: 100%;
}

.agent-share__msg--user {
  justify-content: flex-end;
}

.agent-share__msg--assistant {
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.agent-share__bubble {
  max-width: min(80%, 560px);
  padding: 10px 14px;
  border-radius: 14px;
  font-size: 14px;
  line-height: 22px;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.agent-share__bubble--user,
.agent-share__bubble--error {
  white-space: pre-wrap;
}

.agent-share__bubble--user {
  background: var(--agent-share-accent);
  color: #fff;
  border-bottom-right-radius: 4px;
}

.agent-share__bubble--assistant {
  background: var(--fg-bg-content, #f3f4f6);
  color: var(--fg-text-basic);
  border-bottom-left-radius: 4px;
}

.agent-share__bubble--error {
  background: color-mix(in srgb, var(--fg-anti-red) 12%, #fff);
  color: var(--fg-anti-red);
  border: 1px solid color-mix(in srgb, var(--fg-anti-red) 30%, transparent);
}

.agent-share__bubble-line {
  margin: 0;
}

/* ── 어시스턴트 메시지 마크다운 ── */
.agent-share__markdown {
  font-size: 14px;
  line-height: 22px;
  color: inherit;
}

.agent-share__markdown > *:first-child { margin-top: 0; }
.agent-share__markdown > *:last-child { margin-bottom: 0; }

.agent-share__markdown p {
  margin: 0 0 10px;
}

.agent-share__markdown h1,
.agent-share__markdown h2,
.agent-share__markdown h3,
.agent-share__markdown h4,
.agent-share__markdown h5,
.agent-share__markdown h6 {
  margin: 14px 0 8px;
  font-weight: 700;
  line-height: 1.35;
  color: var(--fg-text-basic);
}

.agent-share__markdown h1 { font-size: 20px; }
.agent-share__markdown h2 { font-size: 18px; }
.agent-share__markdown h3 { font-size: 16px; }
.agent-share__markdown h4,
.agent-share__markdown h5,
.agent-share__markdown h6 { font-size: 14px; }

.agent-share__markdown ul,
.agent-share__markdown ol {
  margin: 0 0 10px;
  padding-left: 20px;
}

.agent-share__markdown li {
  margin: 0 0 4px;
}

.agent-share__markdown li > p {
  margin: 0 0 4px;
}

.agent-share__markdown a {
  color: var(--fg-link, #2563eb);
  text-decoration: underline;
}

.agent-share__markdown a:hover {
  color: var(--fg-link-hover, #1d4ed8);
}

.agent-share__markdown blockquote {
  margin: 0 0 10px;
  padding: 8px 12px;
  background: color-mix(in srgb, var(--agent-share-accent) 8%, #fff);
  border-left: 3px solid color-mix(in srgb, var(--agent-share-accent) 60%, transparent);
  border-radius: 0 8px 8px 0;
  color: var(--fg-text-basic);
}

.agent-share__markdown blockquote > *:last-child { margin-bottom: 0; }

.agent-share__markdown hr {
  border: 0;
  border-top: 1px solid var(--fg-line);
  margin: 14px 0;
}

.agent-share__markdown code {
  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, Consolas, monospace);
  font-size: 13px;
  padding: 1px 6px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 4px;
}

.agent-share__markdown pre {
  margin: 0 0 10px;
  padding: 12px 14px;
  background: #0f172a;
  color: #f8fafc;
  border-radius: 8px;
  overflow-x: auto;
  font-size: 13px;
  line-height: 20px;
}

.agent-share__markdown pre code {
  padding: 0;
  background: transparent;
  color: inherit;
  font-size: inherit;
}

.agent-share__markdown table {
  width: 100%;
  margin: 0 0 10px;
  border-collapse: collapse;
  border: 1px solid var(--fg-line);
  font-size: 13px;
}

.agent-share__markdown th,
.agent-share__markdown td {
  padding: 8px 10px;
  border-top: 1px solid var(--fg-line);
  border-left: 1px solid var(--fg-line);
  text-align: left;
  vertical-align: top;
}

.agent-share__markdown th {
  background: rgba(0, 0, 0, 0.04);
  font-weight: 600;
}

.agent-share__markdown img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

/* 타이핑 인디케이터 */
.agent-share__bubble--typing {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 12px 14px;
}

.agent-share__dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--fg-text-gray);
  animation: agent-share-bounce 1.2s infinite ease-in-out;
}

.agent-share__dot:nth-child(2) { animation-delay: 0.15s; }
.agent-share__dot:nth-child(3) { animation-delay: 0.3s; }

@keyframes agent-share-bounce {
  0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }
  30% { transform: translateY(-4px); opacity: 1; }
}

/* 입력 바 */
.agent-share__inputbar {
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 12px 14px;
  border-top: 1px solid var(--fg-line);
  background: #fff;
}

.agent-share__input {
  flex: 1 1;
  min-height: 40px;
  max-height: 160px;
  padding: 10px 12px;
  background: var(--fg-bg-content, #f6f7fb);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  color: var(--fg-text-basic);
  resize: none;
  transition: var(--transition-fast);
}

.agent-share__input:focus {
  outline: none;
  border-color: var(--agent-share-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--agent-share-accent) 18%, transparent);
}

.agent-share__input:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.agent-share__send {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  background: var(--agent-share-accent);
  border: 0;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-share__send:hover:not(:disabled) {
  filter: brightness(1.08);
  box-shadow: 0 6px 12px color-mix(in srgb, var(--agent-share-accent) 35%, transparent);
}

.agent-share__send:disabled {
  background: var(--fg-text-gray);
  cursor: not-allowed;
}

/* 어시스턴트 메시지 액션(복사/다운로드) */
.agent-share__msg-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  padding-left: 4px;
}

.agent-share__msg-action {
  display: inline-grid;
  place-items: center;
  width: 26px;
  height: 26px;
  padding: 0;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-share__msg-action:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--fg-text-basic);
}

/* 상단바 우측 액션(내보내기) */
.agent-share__topbar-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.agent-share__export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  color: var(--fg-text-basic);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-fast);
}

.agent-share__export-btn:hover:not(:disabled) {
  background: var(--fg-bg-content, #f6f7fb);
  border-color: var(--agent-share-accent);
  color: var(--agent-share-accent);
}

.agent-share__export-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

`, "",{"version":3,"sources":["webpack://./src/css/AgentSharePage.css"],"names":[],"mappings":"AAAA;;2EAE2E;;AAE3E;EACE,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB;;;iCAG+B;EAC/B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA,WAAW;AACX;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4DAA4D;EAC5D,yBAAyB;EACzB,yEAAyE;AAC3E;;AAEA;EACE,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yCAAyC,aAAa,EAAE;AACxD,wCAAwC,gBAAgB,EAAE;;AAE1D;EACE,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,4BAA4B,eAAe,EAAE;AAC7C,4BAA4B,eAAe,EAAE;AAC7C,4BAA4B,eAAe,EAAE;AAC7C;;4BAE4B,eAAe,EAAE;;AAE7C;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kEAAkE;EAClE,qFAAqF;EACrF,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,mDAAmD,gBAAgB,EAAE;;AAErE;EACE,SAAS;EACT,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,uFAAuF;EACvF,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,oCAAoC;EACpC,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,+BAA+B;EAC/B,uDAAuD;AACzD;;AAEA,iCAAiC,sBAAsB,EAAE;AACzD,iCAAiC,qBAAqB,EAAE;;AAExD;EACE,gBAAgB,wBAAwB,EAAE,YAAY,EAAE;EACxD,MAAM,2BAA2B,EAAE,UAAU,EAAE;AACjD;;AAEA,SAAS;AACT;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,qFAAqF;AACvF;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* ========================================================================\n   AgentSharePage — 공유 링크로 진입하는 공개 에이전트 채팅 (/agent/:token)\n   ====================================================================== */\n\n.agent-share {\n  --agent-share-accent: #6c5ce7;\n  height: 100vh;\n  max-height: 100vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background:\n    radial-gradient(1200px 600px at 90% -10%, color-mix(in srgb, var(--agent-share-accent) 12%, transparent), transparent 60%),\n    radial-gradient(900px 600px at -10% 110%, color-mix(in srgb, var(--agent-share-accent) 10%, transparent), transparent 60%),\n    var(--fg-bg-content, #f5f6fa);\n  font-family: var(--font-sans);\n  color: var(--fg-text-basic);\n}\n\n/* 상단 바 — 미니멀한 브랜드 표시만 */\n.agent-share__topbar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n}\n\n.agent-share__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: inherit;\n  text-decoration: none;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.agent-share__brand:hover,\n.agent-share__brand:focus-visible {\n  opacity: 0.75;\n  outline: none;\n}\n\n.agent-share__brand-logo {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n  display: block;\n}\n\n.agent-share__brand-name {\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--fg-text-basic);\n}\n\n/* 메인 — 중앙 컨테이너 */\n.agent-share__main {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 16px 16px;\n}\n\n/* 헤더(에이전트 소개) */\n.agent-share__hero {\n  width: 100%;\n  max-width: 800px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 20px 24px;\n  margin-bottom: 12px;\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(8px);\n  border: 1px solid var(--fg-line);\n  border-radius: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n}\n\n.agent-share__avatar {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  display: grid;\n  place-items: center;\n  border-radius: 14px;\n  background: var(--agent-share-accent);\n  color: #fff;\n}\n\n.agent-share__hero-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.agent-share__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.agent-share__desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n}\n\n.agent-share__desc--error {\n  color: var(--fg-anti-red);\n}\n\n/* 채팅 컨테이너 */\n.agent-share__chat {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  max-width: 800px;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 20px;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.agent-share__scroller {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.agent-share__welcome {\n  margin: auto;\n  padding: 32px 16px;\n  text-align: center;\n  color: var(--fg-text-gray);\n  font-size: 14px;\n}\n\n.agent-share__welcome p {\n  margin: 0;\n}\n\n/* 메시지 버블 */\n.agent-share__msg {\n  display: flex;\n  width: 100%;\n}\n\n.agent-share__msg--user {\n  justify-content: flex-end;\n}\n\n.agent-share__msg--assistant {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.agent-share__bubble {\n  max-width: min(80%, 560px);\n  padding: 10px 14px;\n  border-radius: 14px;\n  font-size: 14px;\n  line-height: 22px;\n  word-break: break-word;\n  overflow-wrap: anywhere;\n}\n\n.agent-share__bubble--user,\n.agent-share__bubble--error {\n  white-space: pre-wrap;\n}\n\n.agent-share__bubble--user {\n  background: var(--agent-share-accent);\n  color: #fff;\n  border-bottom-right-radius: 4px;\n}\n\n.agent-share__bubble--assistant {\n  background: var(--fg-bg-content, #f3f4f6);\n  color: var(--fg-text-basic);\n  border-bottom-left-radius: 4px;\n}\n\n.agent-share__bubble--error {\n  background: color-mix(in srgb, var(--fg-anti-red) 12%, #fff);\n  color: var(--fg-anti-red);\n  border: 1px solid color-mix(in srgb, var(--fg-anti-red) 30%, transparent);\n}\n\n.agent-share__bubble-line {\n  margin: 0;\n}\n\n/* ── 어시스턴트 메시지 마크다운 ── */\n.agent-share__markdown {\n  font-size: 14px;\n  line-height: 22px;\n  color: inherit;\n}\n\n.agent-share__markdown > *:first-child { margin-top: 0; }\n.agent-share__markdown > *:last-child { margin-bottom: 0; }\n\n.agent-share__markdown p {\n  margin: 0 0 10px;\n}\n\n.agent-share__markdown h1,\n.agent-share__markdown h2,\n.agent-share__markdown h3,\n.agent-share__markdown h4,\n.agent-share__markdown h5,\n.agent-share__markdown h6 {\n  margin: 14px 0 8px;\n  font-weight: 700;\n  line-height: 1.35;\n  color: var(--fg-text-basic);\n}\n\n.agent-share__markdown h1 { font-size: 20px; }\n.agent-share__markdown h2 { font-size: 18px; }\n.agent-share__markdown h3 { font-size: 16px; }\n.agent-share__markdown h4,\n.agent-share__markdown h5,\n.agent-share__markdown h6 { font-size: 14px; }\n\n.agent-share__markdown ul,\n.agent-share__markdown ol {\n  margin: 0 0 10px;\n  padding-left: 20px;\n}\n\n.agent-share__markdown li {\n  margin: 0 0 4px;\n}\n\n.agent-share__markdown li > p {\n  margin: 0 0 4px;\n}\n\n.agent-share__markdown a {\n  color: var(--fg-link, #2563eb);\n  text-decoration: underline;\n}\n\n.agent-share__markdown a:hover {\n  color: var(--fg-link-hover, #1d4ed8);\n}\n\n.agent-share__markdown blockquote {\n  margin: 0 0 10px;\n  padding: 8px 12px;\n  background: color-mix(in srgb, var(--agent-share-accent) 8%, #fff);\n  border-left: 3px solid color-mix(in srgb, var(--agent-share-accent) 60%, transparent);\n  border-radius: 0 8px 8px 0;\n  color: var(--fg-text-basic);\n}\n\n.agent-share__markdown blockquote > *:last-child { margin-bottom: 0; }\n\n.agent-share__markdown hr {\n  border: 0;\n  border-top: 1px solid var(--fg-line);\n  margin: 14px 0;\n}\n\n.agent-share__markdown code {\n  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, Consolas, monospace);\n  font-size: 13px;\n  padding: 1px 6px;\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n}\n\n.agent-share__markdown pre {\n  margin: 0 0 10px;\n  padding: 12px 14px;\n  background: #0f172a;\n  color: #f8fafc;\n  border-radius: 8px;\n  overflow-x: auto;\n  font-size: 13px;\n  line-height: 20px;\n}\n\n.agent-share__markdown pre code {\n  padding: 0;\n  background: transparent;\n  color: inherit;\n  font-size: inherit;\n}\n\n.agent-share__markdown table {\n  width: 100%;\n  margin: 0 0 10px;\n  border-collapse: collapse;\n  border: 1px solid var(--fg-line);\n  font-size: 13px;\n}\n\n.agent-share__markdown th,\n.agent-share__markdown td {\n  padding: 8px 10px;\n  border-top: 1px solid var(--fg-line);\n  border-left: 1px solid var(--fg-line);\n  text-align: left;\n  vertical-align: top;\n}\n\n.agent-share__markdown th {\n  background: rgba(0, 0, 0, 0.04);\n  font-weight: 600;\n}\n\n.agent-share__markdown img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n/* 타이핑 인디케이터 */\n.agent-share__bubble--typing {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 14px;\n}\n\n.agent-share__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--fg-text-gray);\n  animation: agent-share-bounce 1.2s infinite ease-in-out;\n}\n\n.agent-share__dot:nth-child(2) { animation-delay: 0.15s; }\n.agent-share__dot:nth-child(3) { animation-delay: 0.3s; }\n\n@keyframes agent-share-bounce {\n  0%, 60%, 100% { transform: translateY(0); opacity: 0.5; }\n  30% { transform: translateY(-4px); opacity: 1; }\n}\n\n/* 입력 바 */\n.agent-share__inputbar {\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  padding: 12px 14px;\n  border-top: 1px solid var(--fg-line);\n  background: #fff;\n}\n\n.agent-share__input {\n  flex: 1;\n  min-height: 40px;\n  max-height: 160px;\n  padding: 10px 12px;\n  background: var(--fg-bg-content, #f6f7fb);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--fg-text-basic);\n  resize: none;\n  transition: var(--transition-fast);\n}\n\n.agent-share__input:focus {\n  outline: none;\n  border-color: var(--agent-share-accent);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--agent-share-accent) 18%, transparent);\n}\n\n.agent-share__input:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.agent-share__send {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  background: var(--agent-share-accent);\n  border: 0;\n  border-radius: 12px;\n  color: #fff;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-share__send:hover:not(:disabled) {\n  filter: brightness(1.08);\n  box-shadow: 0 6px 12px color-mix(in srgb, var(--agent-share-accent) 35%, transparent);\n}\n\n.agent-share__send:disabled {\n  background: var(--fg-text-gray);\n  cursor: not-allowed;\n}\n\n/* 어시스턴트 메시지 액션(복사/다운로드) */\n.agent-share__msg-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n  padding-left: 4px;\n}\n\n.agent-share__msg-action {\n  display: inline-grid;\n  place-items: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-share__msg-action:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--fg-text-basic);\n}\n\n/* 상단바 우측 액션(내보내기) */\n.agent-share__topbar-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.agent-share__export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.agent-share__export-btn:hover:not(:disabled) {\n  background: var(--fg-bg-content, #f6f7fb);\n  border-color: var(--agent-share-accent);\n  color: var(--agent-share-accent);\n}\n\n.agent-share__export-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
